import React from 'react';
import PropTypes from 'prop-types';
import { CustomSelect, Option } from '@src/components';

const DayCount = ({ dayCount, onChange, maxDayCount }) => {
  const handleDayCountChange = (value) => {
    onChange(value);
  };

  const generateOptions = () => {
    const options = [];
    for (let i = 1; i <= maxDayCount; i++) {
      options.push(
        <Option key={i} value={i}>
          {i}
        </Option>
      );
    }
    return options;
  };

  return (
    <>
      <CustomSelect value={dayCount} height={40} onChange={handleDayCountChange} style={{ display: 'flex', flexDirection: 'row', marginLeft: '8px' }}>
        {generateOptions()}
      </CustomSelect>
      <div className="info-text" style={{ color: '#00a483', fontSize: '14px' }}>=</div>
    </>
  );
};

DayCount.propTypes = {
  dayCount: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  maxDayCount: PropTypes.number.isRequired,
};

export default DayCount;
